/*
 * @Author: your name
 * @Date: 2021-08-19 19:34:43
 * @LastEditTime: 2021-09-27 17:03:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \鲁南\src\modules\fire\api\index.js
 */
export const api = {
    getEmergencyPlanListByAlarmType: '/bas/emergency/queryEmergencyPlanListApi.json',
    queryConfigTypeList: "/bms/device/queryFireFightingOperationConfigTypeList.json",//获取操作类型列表
    control: {
        queryBuildingDeviceTree: '/bms/device/queryBuildingDeviceTree.json', //消防控制 查询楼栋/楼层设备树
        queryDeviceWorkGroupDeviceTree: '/bms/device/queryDeviceWorkGroupDeviceTree.json', //查询消防设备组设备树
        queryFireDeviceList: '/bms/device/queryFireDeviceListApi.json', //查询消防设备
        queryFirefightingDeviceList: '/bas/firefightoperation/queryFirefightingDeviceList.json', //查询设备系统
    },
    historyAlarm: {
        searchAlarm: '/bas/alarmSafeEvent/queryHistoryFireAlarm.json', // 历史告警筛选
        exportAlarm: '/bas/safeEvent/exportHistoryAlarm.json', // 导出历史告警,
        getTaskDetail: '/bas/taskcenter/queryTaskInfo.json', // 查看任务详情
    },
    alarm: {
        confirmFirefightingSafeEvent:'/bas/alarmSafeEvent/confirmFirefightingSafeEvent.json',//事件确认
        updateAlarm: "/bas/alarmSafeEvent/updateSafeEvent.json", // 安全事件告警处理
        queryTaskInfo: "/bas/taskcenter/queryTaskInfo.json",
        getAlarmTypeAndSubsystem: '/bas/alarmSafeEvent/queryAlarmTypeAndSubsystem.json', //消防告警 查询告警类型/子系统列表
        getAlarmPageList: '/bas/alarmSafeEvent/queryFirefightingAlarmResultsByPage.json', //查询告警列表
        queryAlarmDetail: '/bas/alarmSafeEvent/queryResult.json', //查询告警详情
        missReport: '/bas/alarmSafeEvent/missFirefightingAlarmReport.json', // 误报
        getWorkingList: '/bas/firefightoperation/queryFirefightingOperationList.json', //查询运行数据列表
        batchMissReport: '/bas/alarmSafeEvent/updateMergeMisinformationAlarm.json', // 批量误报
        queryAlarmMergeAlarmList: '/bas/alarmSafeEvent/queryAlarmMergeAlarmList.json', // 获取合并列表
        getDeviceVideo: "/bms/device/queryFirefightingCameraList.json", //查询设备视频，
        startEmergency: '/bas/emergency/addEmergencyRecord.json',
        getalarmList: '/bms/device/queryElectricalFireAlarmInfo.json',
        queryFirefightingAlarmDeviceList: '/bas/alarmSafeEvent/queryFirefightingAlarmDeviceList.json', //查询告警周边的设备
        updateFirefightingSafeEvent: '/bas/alarmSafeEvent/updateFirefightingSafeEvent.json', //修改消防告警的基本信息中的字段
        queryQuickLabelList: '/common/quicklabel/queryQuickLabelList.json', // 查询快捷标签列表
    },
    cms: {
        addAlarmIgnoreConfig: '/cms/accessportal/addAlarmIgnoreConfig.json', //添加告警抑制
        queryAlarmIgnoreConfigInfo: '/cms/accessportal/queryAlarmIgnoreConfigInfo.json', //查寻告警抑制
        queryBuildingTree: '/cms/building/queryBuildingTree.json', //查询楼层、楼栋
        queryFireDevice: 'cms/accessportal/queryFireDeviceApi.json', //获取消防设备list
        updateFireDevice: '/cms/accessportal/updateFireDeviceApi.json', //修改设备主机信息
        updateFireSubDevice: '/cms/accessportal/updateFireSubDeviceApi.json', //修改部件信息
        queryBuilding: '/cms/building/queryBuildingList.json', //修改部件信息
    },
    controlRecord: {
        queryFirefightControlRecordList: '/bas/firefightcontrol/queryFirefightingControlRecordList.json', //控制记录 查询控制记录列表
        exportFirefightControlRecordList: '/bas/firefightcontrol/exportFirefightingControlRecordList.json', //导出消防控制记录
        addAlarmFunctionConfig: '/bas/alarmSafeEvent/addAlarmFunctionConfig.json', //告警合并
        deleteAlarmFunctionConfig: '/bas/alarmSafeEvent/deleteAlarmFunctionConfig.json', //告警合并取消
        updateAlarmHostReset: '  /bas/safeEvent/updateAlarmHostReset.json', //主机复位
        // controlFirefighting: '/bas/firefightcontrol/controlFirefighting.json', //;联防控制器
        controlFirefighting: '/bas/firefightcontrol/controlFirefightingApi.json', //;联防控制器
        batchUpdateMergeAlarm: '/bas/alarmSafeEvent/batchUpdateMergeAlarm.json', //;批量处理合并告警信息
        queryFirefightingControlReply: '/bas/firefightcontrol/queryFirefightingControlReply.json', // 查询控制器回调
    },
    device: {
        getDeviceDetails: '/bms/device/queryDeviceDetails.json', //获取消防设备详情
        queryFactoryList: 'cms/accessportal/queryFireDeviceFactoryList.json', //查询厂商列表
        queryDeviceListByBuilding: '/bas/alarmSafeEvent/queryDeviceListByBuilding.json', //根据楼栋/楼层查询设备列表
        updateDeviceBuilding: '/cms/building/updateDeviceBuilding.json', //修改设备位置
    },
    record: {
        queryHistoryFireAlarm: '/bas/alarmSafeEvent/queryHistoryFireAlarm.json', // 历史告警筛选
        exportHistoryFireAlarm: ' /bas/alarmSafeEvent/exportHistoryFireAlarm.json' //导出消防报警
    },
    config: {
        queryConfigList: '/bms/device/queryFireFightingOperationConfigListApi.json', //查询配置
        addConfigStep: '/bms/device/addFireFightingOperationConfigApi.json', //新增步骤
        updateConfigStep: '/bms/device/updateFireFightingOperationConfigApi.json', //修改步骤
        deleteConfigStep: '/bms/device/deleteFireFightingOperationConfigApi.json', //删除步骤
        getDeviceDetail: "/bms/device/queryDeviceDetails.json", //查询设备信息,
    },
    video: {
        updateFirefightingCamera: '/bms/device/updateFirefightingCamera.json', // 修改视频配置
        queryFirefightingCameraList: '/bms/device/queryFirefightingCameraList.json ', // 查询视频配置信息
    }
}
